// extracted by mini-css-extract-plugin
module.exports = {"block":"DetailsNcaa_block__hVcjN"};